import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Card from "../../../Components/MA/ListCard/Card";
import MALayout from "../../../Components/M&ALayout";
import MainMenu from "../MA_MainMenu";
import Table from "../../../Components/Acquirer/TableComponent";
import FilterTag from "../../../Components/Tag";
import RefineSearchBar from "../../../Components/RemovedArrowRefineSearch";
import Constants from "../../../Constants";
import xls from "../../../images/xls/png/Group 47.png";
import line from "../../../images/line.png";
import moment from "moment";
import FileIcon from "../../../images/file.png";
import FileIconBlur from "../../../images/fileblur.png";
import MonthPickerComponent from "../../../Utils/MonthPickerComponent";
import SavedFilterContent from "../../../Components/SavedFilter";
import { TableDataContext } from "../../../Contexts/TableDataContext";
import { maAcquirerListExportApi } from "../../../Config/config";
import ExportPopup from "../../../Components/ExportPopup";
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import { maAcquirerProfileExportData } from "../../../Components/ExportPopup/ExportData";
import { UserContext } from "../../../Contexts/UserContext";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../../../Components/ExportPopup/DownloadTrigger";
import Sidebar from "../../../Components/RefineSearchComponent";
import MaCompaniesRefineSearch from "../../../Components/RefineSearch/MaCompaniesRefineSearch";
import { FaFilter } from "react-icons/fa";
// import { IoClose  } from "react-icons/io5";
/* The above code is a React component called "Acquirer". It is a part of a larger application and is
responsible for rendering a page that displays a table of acquirer data. */
function Acquirer(props) {
  const [showPopup, setShowPopup] = useState();
  const [openTab, setOpenTab] = React.useState(1);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);
  // const [save, setSave] = useState(false);
  const savedList = () => {
    setSave(!save);
  };
  useEffect(() => {
    setOpenTab(props.active);
  }, [openTab]);
  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }    },[])
  const { save, setSave, showMonthPicker, refineSearchFilters, groupId, isMobile,setOpen,open,setIsMobile } =
    useContext(PeFilterContext);
  const { globalSearchResult } = useContext(TableDataContext);
  const { pathname } = useLocation();
  const { isTrialExport, isStudent } = useContext(UserContext);

  /**
   * The function checks if there are any global search filters applied
   */
  const isFromGlobalSearch = () =>
    refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;

  return (
    <MALayout menu="ma">
      <div className="flex min-h-screen h-screen flex-col">
        {/* Top nav*/}
        <Card menu="acquirers"/>
        {/* Bottom section */}

        <div
          className={"flex min-h-0 flex-1 overflow-hidden"}
        >
          {/* Narrow sidebar*/}
          {/* Main area */}
          <main className="min-w-0 flex-1 border-t border-gray-200 lg:flex">
            {/* Primary column */}
            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
              {/* Your content */}
                {isMobile ? (<FilterTag />) : null }
              <div className="mx-4 mt-4 rounded-t-md bg-white flex items-center justify-between ">
                <div className="pr-4 lg:pr-4 md:pr-[0.7rem]  w-[100%]">
                    <div className=" rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between">
                    {!isMobile ? (<div className="mt-1">
                        <FilterTag />  
                    </div>) : null }
                      <div
                        className={
                          "justify-between items-center px-2 py-2 space-x-4 " +
                          (showMonthPicker != 0 ? "md:flex" : "flex")
                        }
                      >
                        <label htmlFor="" className="text-[#666666] ">
                          <div className={showMonthPicker != 0 ? "" : "flex"}>
                            <MonthPickerComponent />
                          </div>
                        </label>

                        <div
                          className={
                            showMonthPicker != 0
                              ? "hidden md:flex space-x-3"
                              : "flex space-x-3"
                          }
                        >
                        {/* <button
                          className="cursor-pointer lg:ml-7 ml-4 mt-2"
                          onClick={() => setOpen(!open)}
                          >
                            <FaFilter color="#bc8b20" size={21} />
                        </button> */}
                        <a>
                            <img
                                className="h-[24px] max-w-[2px] mt-1 "
                                src={line}
                            />
                        </a>
                          {isTrialExport == 'false'|| isStudent == "true" ? (
                            <></>
                          ) : (
                            <>
                              <button>
                                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                {showPopup && (
                                  <ExportPopup
                                    modules="ma-acquirer"
                                    fileName={
                                      Constants.exportNames.ma_acquirers
                                    }
                                    url={maAcquirerListExportApi}
                                    onClose={() => setShowPopup(false)}
                                    exportOptions={maAcquirerProfileExportData}
                                  />
                                )}
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {save ? (
                      <SavedFilterContent
                        primaryTypeMasterId={Constants.primaryMasterIds.mANDaId}
                        typeId={Constants.moduleIds.acquirer_id}
                        show={save}
                      />
                    ) : (
                      ""
                    )}
                  </div>
              </div>
              <div className="overflow-y-auto">
                <Table
                  menu="ma"
                  sub_type_master_id={Constants.subCategoryIds.ma_acquirer_id}
                />
              </div>
            </section>
            {/* Secondary column (hidden on smaller screens) */}
            <aside className=" lg:order-first lg:block lg:flex-shrink-0">
              <div className="relative flex h-full  flex-col border-r border-gray-200 bg-[#FAF5EA]">
                {/* Your content */}
                <Sidebar>
                  <MaCompaniesRefineSearch customPathname={pathname} />
                </Sidebar>
              </div>
            </aside>
          </main>
        </div>
      </div>
    </MALayout>
  );
}

export default Acquirer;
